import { Skeleton } from '../atoms/Skeleton'

export function PageSkeleton() {
	return (
		<div aria-label="Loading" aria-busy="true">
			<Skeleton className="h-7 w-48 mb-5" />
			<div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
				{Array.from({ length: 4 }).map((_, i) => (
					<div key={i} className="bg-background rounded-xl border border-border p-4">
						<Skeleton className="h-3 w-24 mb-3" />
						<Skeleton className="h-7 w-16" />
					</div>
				))}
			</div>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				{Array.from({ length: 2 }).map((_, i) => (
					<div key={i} className="bg-background rounded-xl border border-border p-5">
						<Skeleton className="h-4 w-32 mb-4" />
						{Array.from({ length: 3 }).map((_, j) => (
							<div key={j} className="py-3 border-b border-border last:border-0">
								<Skeleton className="h-4 w-full" />
							</div>
						))}
					</div>
				))}
			</div>
		</div>
	)
}
